export default "__VITE_ASSET__CR8H3xfA__"